import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { Observable } from 'rxjs';

const STORAGE_KEY = 'actingCompanyId';

/**
 * HTTP Interceptor that adds the X-Acting-Company-Id header
 * when a super admin is acting as another company.
 *
 * Note: We read directly from localStorage instead of depending on
 * CurrentUserService.isSuperAdmin() to avoid race conditions after page reload.
 * The backend validates that only super admins can use this header.
 */
@Injectable()
export class CompanyContextInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    // Read directly from localStorage (synchronous, no race condition)
    const actingCompanyId = localStorage.getItem(STORAGE_KEY);

    if (!actingCompanyId) {
      return next.handle(req);
    }

    // Clone the request and add the header
    const modifiedReq = req.clone({
      headers: req.headers.set('X-Acting-Company-Id', actingCompanyId),
    });

    return next.handle(modifiedReq);
  }
}

export const companyContextInterceptor = {
  provide: HTTP_INTERCEPTORS,
  useClass: CompanyContextInterceptor,
  multi: true,
};
